import React, { useState, useRef } from "react";
import { Table, Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./comp-table-mdfe.css";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";

const CompTableMdfe = ({ data, rowSelection }) => {
  // 1. Estados necessários para o filtro
  const [selectionType, setSelectionType] = useState("checkbox");
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  // 2. Funções de manipulação do filtro (Copiadas do seu exemplo)
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length > 0) {
      if (selectedKeys[0].trim().length > 0) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
      } else {
        confirm();
        setSearchText("");
        setSearchedColumn(dataIndex);
      }
    } else {
      confirm();
      setSearchText("");
      setSearchedColumn(dataIndex);
    }
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
          backgroundColor: "#FCFCFCFF",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          color: "white",
          fontSize: "14px",
          fontWeight: 600,
          border: "1px solid #0124434B",
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
            width: "100%",
            borderRadius: "8px",
            border: "1px solid #d9d9d9",
            padding: "8px 12px",
            fontSize: "14px",
            boxShadow: "inset 0 2px 6px rgba(0,0,0,0.1)",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="large"
            style={{
              width: 90,
              fontWeight: 600,
              backgroundColor: "#012443",
              borderTop: "1px solid rgba(1,36,67,0.1)",
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="large"
            style={{
              width: 90,
              fontWeight: 600,
              backgroundColor: "#FF3100",
              color: "white",
              borderColor: "#FF3100",
              height: "40px",
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
            style={{
              fontWeight: 600,
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
            style={{
              fontWeight: 600,
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      // Lógica para lidar com arrays (objetos aninhados) ou strings simples
      if (Array.isArray(dataIndex)) {
        let valorRegistro = record;
        for (let key of dataIndex) {
          valorRegistro = valorRegistro ? valorRegistro[key] : null;
        }
        return valorRegistro
          ? valorRegistro.toString().toLowerCase().includes(value.toLowerCase())
          : false;
      }
      return record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : false;
    },
  });

  // 3. Definição das colunas com o filtro aplicado
  const columns = [
    {
      title: "Numero Nfe",
      dataIndex: "numeroNfe",
      ...getColumnSearchProps("numeroNfe"), // Filtro aplicado
    },
    {
      title: "Embarcador",
      dataIndex: "shipper",
      // ...getColumnSearchProps('embarcador'),
    },
    {
      title: "Chave",
      dataIndex: "chave",
      ...getColumnSearchProps("chave"), // Filtro aplicado
    },
    {
      title: "DFe",
      dataIndex: "dfe",
    },
    {
      title: "Valor NF",
      dataIndex: "valorNf",
    },
    {
      title: "Peso Liquido",
      dataIndex: "pesoL",
    },
    {
      title: "Peso Bruto",
      dataIndex: "pesoB",
    },
  ];


 return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        padding: "16px",
        width: "100%",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
        minHeight: "400px", 
        display: "flex",
        flexDirection: "column",
        justifyContent: !data ? "center" : "flex-start",
        alignItems: !data ? "center" : "stretch",
        
      }}
    >
      {!data ? (
        
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
             <CircularProgress enableTrackSlot size="3rem" />
             <span style={{ color: '#012443', fontWeight: 500 }}>Carregando notas...</span>
        </div>
      ) : (
        <Table
          rowKey={(_, index) => index}
          rowSelection={{ type: selectionType, ...rowSelection }}
          columns={columns}
          dataSource={data}
          scroll={{ x: "max-content" }}
          className="custom-ant-table"
          
        />
      )}
    </div>
  );
};
export default CompTableMdfe;
